// The call recording: three Opus tracks (mixed, inbound, outbound) uploaded
// to service-ws after hang-up.
//
// Each track goes in its own request. All three in one request passed Cloud
// Run's 32 MiB request limit on calls of about 8 minutes, and the recording
// was lost. At RECORDING_BITRATE a track is about 14 MB per hour.

export const RECORDING_MIME = 'audio/webm;codecs=opus';
// Speech: the agent's audio arrives at 24 kHz, and WebRTC itself carries
// voice at about this rate. The browser default (about 190 kbps) made a
// 10-minute call 43 MB.
export const RECORDING_BITRATE = 32_000;

export type Tracks = { mixed: Blob[]; inbound: Blob[]; outbound: Blob[] };
export type StreamMeta = { audioStreamPath: string; streamSid: string };

/** Upload each non-empty track; resolves when all requests have settled. */
export const uploadTracks = async (
  url: string,
  meta: StreamMeta,
  tracks: Tracks,
  post: (url: string, body: FormData) => Promise<unknown> = (u, body) => fetch(u, { method: 'POST', body }),
) => {
  const sends = (Object.keys(tracks) as (keyof Tracks)[])
    .filter((name) => tracks[name].length > 0)
    .map((name) => {
      const form = new FormData();
      form.append(name, new Blob(tracks[name], { type: RECORDING_MIME }), `${name}.webm`);
      form.append('audioStreamPath', meta.audioStreamPath);
      form.append('streamSid', meta.streamSid);
      return post(url, form).catch((e) => console.error(`[talk:webrtc] ${name} recording upload failed:`, e));
    });
  await Promise.all(sends);
};
